import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, ReplaySubject} from 'rxjs';
import {Regional} from '../interface/regional';
import {first, take} from 'rxjs/operators';
import {ListResponse} from '../interface/response/list-response';
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {PartnerFacility} from "../interface/partner-facility";
import {FilterService} from "./filter.service";
import {Meeting} from "../interface/meeting";

@Injectable({
  providedIn: 'root'
})
export class RegionalService {
  private readonly regionalsDictSubject: ReplaySubject<Array<Regional>>;
  private readonly regionalsListSubject: ReplaySubject<CountedAndPaginated<Regional>>
    = new ReplaySubject<CountedAndPaginated<Regional>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService) {
    this.regionalsDictSubject = new ReplaySubject<Array<Regional>>(1);
    this.loadDict();
  }

  public loadDict(): void {
    this.httpClient.get('/rest/crm/dictionary/regional')
      .pipe(take(1))
      .subscribe((result: ListResponse<Regional>) => {
        this.regionalsDictSubject.next(result.items);
      });
  }
  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/regional?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<Regional>) => {
        this.regionalsListSubject.next(result);
      });
  }

  public getRegionalListSubject(): ReplaySubject<CountedAndPaginated<Regional>> {
    return this.regionalsListSubject;
  }
  public getRegionalsDictSubject(): ReplaySubject<Array<Regional>> {
    return this.regionalsDictSubject;
  }

  public getRegional(id: string): Observable<Regional> {
    this.loadDict();

    const result: ReplaySubject<Regional> = new ReplaySubject<Regional>(1);

    this.regionalsDictSubject
      .pipe(first())
      .subscribe((regionals: Array<Regional>) => {
        regionals.forEach((regional: Regional) => {
          if (regional.uuid === id) {
            result.next(regional);
          }
        });
      });

    return result;
  }

  get(regionalId: string): Observable<Regional> {
    return this.httpClient.get(`/rest/crm/regional/${regionalId}`)
      .pipe(first()) as Observable<Regional>;
  }

  public sendForm(formData: object, regionalId?: string): Observable<any> {
    if (regionalId) {
      return this.httpClient.put(`/rest/crm/regional/${regionalId}`, formData)
        .pipe(
          take(1)
        );
    } else {
      return this.httpClient.post('/rest/crm/regional', formData)
        .pipe(
          take(1)
        );
    }
  }
}
